import React, { Component } from 'react';
import { connect } from 'react-redux';
import Banner from '../../layout/Banner';
import { Row, Col } from 'antd';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';
import PortfolioImage from './PortfolioImage';
import { StaticQuery, graphql } from 'gatsby';

import * as routes from '../../constants/routeNames';
import * as rThad from '../../state/thad';

const mapDispatchToProps = (dispatch) => ({
	onSetPage: (page) => {
		dispatch(rThad.setPage(page));
	}
});
interface DispatchProps {
	onSetPage: Function;
}

const mapStateToProps = (state) => ({});
interface StateProps {}
interface OwnProps {}
type Props = DispatchProps & StateProps & OwnProps;
type State = {
	currentImage: number;
	lightboxIsOpen: boolean;
	sortType: string;
	sortedImages: Array<any>;
	selectedPortfolio: any;
};

const types = [ 'All', 'Transitional', 'Modern', 'Traditional', 'Semi-Detached + Duplex' ];

class PortfolioRoot extends Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			currentImage: 0,
			lightboxIsOpen: false,
			sortType: 'All',
			sortedImages: [],
			selectedPortfolio: { interiors: [] }
		};
	}
	componentDidMount() {
		this.props.onSetPage(routes.PORTFOLIO);
	}
	columns = (containerWidth) => {
		let columns = 1;
		if (containerWidth >= 500) columns = 2;
		if (containerWidth >= 900) columns = 3;
		if (containerWidth >= 1500) columns = 4;
		return columns;
	};
	openLightbox = (event, obj) => {
		this.setState({
			currentImage: 0,
			lightboxIsOpen: true,
			selectedPortfolio: obj.photo
		});
	};
	closeLightbox = () => {
		this.setState({
			currentImage: 0,
			lightboxIsOpen: false
		});
	};
	gotoPrevious = () => {
		this.setState({
			currentImage: this.state.currentImage - 1
		});
	};
	gotoNext = () => {
		this.setState({
			currentImage: this.state.currentImage + 1
		});
	};
	onClickThumbnail = (index: number) => {
		this.setState({
			currentImage: index
		});
	};
	sortImages = (type: String, data: any) => {
		if (type === 'All') {
			this.setState({ sortedImages: [] });
		} else {
			const images = this.convertDataToImages(data);
			const sortedImages = images.filter((image) => image.type === type);
			this.setState({ sortedImages });
		}
	};
	convertDataToImages = (data: any): Array<any> => {
		const images = data.allContentfulPortfolio.edges.map((edge, index) => {
			const interiors = edge.node.interiorImages.map((interior, index) => {
				return {
					src: interior.fluid.src
					// height: 10,
					// width: interior.fluid.aspectRatio * 10
				};
			});
			return {
				...edge.node,
				src: edge.node.featuredImage.fluid.src,
				height: 10,
				width: edge.node.featuredImage.fluid.aspectRatio * 10,
				interiors
			};
		});
		return images;
	};
	render() {
		return (
			<StaticQuery
				query={graphql`
					query Portfolio {
						allContentfulPortfolio {
							edges {
								node {
									title
									type
									alt
									caption
									featuredImage {
										fluid {
											aspectRatio
											src
											srcSet
											srcSetWebp
											sizes
										}
									}
									interiorImages {
										fluid {
											aspectRatio
											src
											srcSet
											srcSetWebp
											sizes
										}
									}
								}
							}
						}
					}
				`}
				render={(data) => (
					<div style={{ minHeight: 'calc(100vh - 64px' }}>
						<Banner />
						<Row className='uk-padding' type='flex' justify='space-around' align='middle'>
							{types.map((type) => {
								return (
									<Col
										onClick={() => {
											this.setState({
												sortType: type
											});
											this.sortImages(type, data);
										}}
										key={type}
										className='uk-padding-small category'
									>
										<div className={`inside ${this.state.sortType === type ? 'active' : ''}`}>
											{type}
										</div>
									</Col>
								);
							})}
						</Row>
						<Gallery
							onClick={this.openLightbox}
							direction='column'
							margin={1}
							photos={
								this.state.sortedImages.length !== 0 ? (
									this.state.sortedImages
								) : (
									this.convertDataToImages(data)
								)
							}
							columns={this.columns}
							ImageComponent={PortfolioImage}
						/>
						<div className='uk-margin-large-bottom' />
						{this.state.selectedPortfolio.interiors.length !== 0 && (
							<Lightbox
								images={this.state.selectedPortfolio.interiors}
								onClose={this.closeLightbox}
								onClickPrev={this.gotoPrevious}
								onClickNext={this.gotoNext}
								currentImage={this.state.currentImage}
								isOpen={this.state.lightboxIsOpen}
								backdropClosesModal={true}
								showThumbnails={true}
								onClickThumbnail={this.onClickThumbnail}
							/>
						)}
					</div>
				)}
			/>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioRoot);

// getImageDimensions = (file) => {
//   return new Promise(function(resolved, rejected) {
//     var i = new Image();
//     i.onload = function() {
//       resolved({ w: i.width, h: i.height });
//     };
//     i.src = file;
//   });
// };
// getImages = () => {
//   const promiseArray = images.map((image) => {
//     return this.getImageDimensions(image.src);
//   });
//   return Promise.all(promiseArray)
//     .then((results) => {
//       const newImages = results.map((result: any, index: number) => {
//         return {
//           ...images[index],
//           height: result.h,
//           width: result.w
//         };
//       });
//       newImages.forEach((image) => {
//         image.interiors = [ newImages[1], newImages[2], newImages[3] ];
//       });
//       this.setState({ images: newImages });
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// };
